import { render, staticRenderFns } from "./trouble-notifications-not-working.vue?vue&type=template&id=655f59db"
import script from "./trouble-notifications-not-working.vue?vue&type=script&lang=js"
export * from "./trouble-notifications-not-working.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports